<template>
  <template-corporation
    :hasFinalTaxType="hasFinalTaxType"
    :fact="fact"
    :penalty="penalty"
    :pathName="pathName"
  >
    <div slot="to-do">
      <div class="contents">
        <span>6. </span>
        <span class="wld-link">
          <span class="bold">เพื่อผลประโยชน์สูงสุดในการดำเนินกิจการ</span>
          เราแนะนำให้ซื้อสินค้ากับผู้ประกอบการทจดทะเบียน ภาษีมูลค่าเพิ่ม (VAT)
          แล้ว
        </span>
      </div>
    </div>
  </template-corporation>
</template>

<script>
export default {
  name: "CorpRegisteredhWitoutVat",
  props: ["hasFinalTaxType"],
  data() {
    return {
      pathName: "corp_registered_without_vat",
      fact: [
        "คุณจะมีค่าใช้จ่ายเพิ่มเติมที่ตามมาหลังจด VAT คือ ค่าใช้จ่ายในการทำบัญชีและตรวจสอบบัญชี",
        "การไม่จด VAT ทำให้คุณไม่มีหลักฐานเพื่อช่วยในการขอเครดิตจากธนาคารในกรณีที่คุณต้องการเงินทุนเพื่อขยายกิจการในอนาคต",
        "การซื้อสินค้าจากผู้ประกอบการที่ไม่จด VAT ทำให้คุณต้องแบกรับภาระค่าใช้จ่ายทางภาษีเอาไว้เอง เพราะไม่สามารถขอคืนภาษีซื้อได้",
      ],
    };
  },
  methods: {
    goVatDefinition() {
      this.$router.push({
        path: "/info/vat_definition",
      });
    },
    goVatBenefit() {
      this.$router.push({
        path: "/info/vat_benefit",
      });
    },
    goPurchaseTax() {
      this.$router.push({
        path: "/info/purchase_tax",
      });
    },
  },
};
</script>

<style scoped>
.lable-alert {
  color: #f45a49;
  font-weight: bold;
}
</style>
